import { useDateFormatter } from '@/hooks/useDateFormatter'
import { useUI } from '@/hooks/useUI'
import { useTranslation } from 'react-i18next'
import type { TransferDetail } from '../../types/transferRequest'

export function ScheduleInfo({ transfer }: { transfer: TransferDetail }) {
  const { t } = useTranslation()
  const { deliveryMethods, getEnumLabel } = useUI()
  const { formatDateTime } = useDateFormatter()
  const deliveryMethodLabel = getEnumLabel(deliveryMethods, transfer.deliveryMethod, transfer.deliveryMethod || '-')
  const scheduledDate = formatDateTime(transfer.scheduledDate, { day: 'numeric', month: 'long', year: 'numeric' })

  return (
    <div className="rounded-lg border border-border/30 bg-secondary/20 p-3">
      <p className="text-xs text-muted-foreground">
        {t('requests.scheduleInfo', { method: deliveryMethodLabel, date: scheduledDate })}
      </p>
    </div>
  )
}
